import { render, staticRenderFns } from "./MalattieInfettiveListComponent.vue?vue&type=template&id=476ab18b"
import script from "./MalattieInfettiveListComponent.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports